import ListContainer from '../../../../presentation/ListContainer';
import PageAuthorize from '../../../../security/PageAuthorize';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import layout from './layout.json';

class SpoofContainer extends React.Component {
  render() {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management']}>
        <ListContainer title='Call History' layout={layout} selectedtab={1}/>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( SpoofContainer )
);


// WEBPACK FOOTER //
// ./src/content/enterprise/spoof/components/SpoofContainer.js